/**
 * 合同类型枚举
 */
export enum ContractTypeEnum {
  /** PDF 类型 */
  PDF = 1,
  /** HTML 类型 */
  HTML = 2,
}

/**
 * 合同/协议列表项（通用）
 */
export interface ContractListItem {
  /** 合同名称 */
  name: string;
  /** 合同链接 */
  url: string;
  /** 合同类型（可选，不传按 HTML 处理） */
  type?: ContractTypeEnum;
}

export interface ContractListResponse {
  /** 产品id */
  productId: string;
  /** 产品名称 */
  productName: string;
  /** 产品图标 */
  productIcon: string;
  /** 合同列表 */
  contractList: ContractListItem[];
}

/**
 * 渠道协议信息（channel-contract-list 组件使用，支持选择功能）
 */
export interface ChannelContractInfo extends ContractListResponse {
  /** 是否选中（外层传入，用于"获得更多额度"功能） */
  isSelected?: boolean;
}

/**
 * 渠道信息扩展（组件内部使用，添加交互状态）
 */
export interface ChannelInfoExtend extends ChannelContractInfo {
  /** 当前选中的协议索引 */
  contractActive: number;
  /** 是否展开 */
  isExpand: boolean;
}
